import { Banner } from '@/components/ui/banner'
import { Link } from '@/components/ui/Link'
import { customerTabHref } from '@/lib/customerTabs'
import type { FillOrgRef } from '@/models/fillApplication'

/** So a rep doesn't build a second customer for a carrier Cai already has. */
export function DuplicateCustomerNotice({ duplicate }: { duplicate: FillOrgRef }) {
  return (
    <Banner variant="warning" small>
      Another customer already has this DOT:{' '}
      <Link kind="util" emphasis href={customerTabHref(duplicate.id)}>
        {duplicate.name}
      </Link>
      . Check it isn&apos;t the same business before you go on.
    </Banner>
  )
}
